<template>
  <!-- Standard -->
  <div class="index_standard">
    <div class="container1500">
      <div class="index_standard_title">
        <div>{{ $t('index.third.title') }}</div>
      </div>

      <div class="standard_content">
        <div
          class="standard_item"
          v-for="(item, index) in standardList"
          :key="index"
        >
          <div class="standard_item_title">
            <div class="standard_item_title_left">0{{ index + 1 }}</div>
            <div class="standard_item_title_right">
              <div>{{ item.title.zh }}</div>
              <div>{{ item.title.en }}</div>
            </div>
          </div>
          <div class="standard_item_content">
            <!-- <div class="standard_item_content_box">{{ item.content }}</div> -->
            <div class="standard_item_step">
              <div
                v-for="(i, index1) in item.stepsList"
                :key="index1"
                class="standard_item_step_item"
              >
                <img src="@/assets/images/yes_svg.svg" alt="" />
                {{ i.title }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStandardList } from "@/api/index/index";
export default {
  data() {
    return {
      standardList: [
        {
          title: { en: "Initial Triage", zh: "初始分存活" },
          content:
            "第一阶段需要审核7个标准，是期刊最基础的信息，目的是为了确保审核人员能在及时和准确的联系到期刊。一般正常运营的期刊都能够通过第一阶段的评估；若未通过也不必担心，调整后，期刊可随时再次提交申请。第一阶段审核标准包括：",
          stepsList: [],
        },
        {
          title: { en: "Editorial Triage", zh: "编辑形式分档次" },
          content:
            "第二阶段的审核包括9个标准，Web of Science指出，第二阶段的审核目的在于决策是否此本期刊值得去全面的评估。<箭弩学术>认为，第二阶段的9个标准主要是用来检测期刊的发行是否标准化、规律化，以及符合学术道德标准。第二阶段审核标准包括：",
          stepsList: [],
        },
        {
          title: { en: "Editorial Evaluation - Quality", zh: "编辑质量定成败" },
          content:
            "当期刊进入到了第三阶段，Web of Science 的考核才正式开始。第三阶段包含8个标准，这些标准相对于第二阶段来说脱离于量化的概念，每项标准的考核更加全面化，多角度。期刊应从多方面向WOS编辑证明，此期刊符合某条标准。如果期刊在本阶段未通过，则将受到两年的embargo, 也就是说两年内不能再次申请核心期刊收录的审核。从此标准可以看出，第三阶段的审核更为复杂和严格。第三阶段审核标准包括：",
          stepsList: [],
        },
        {
          title: {
            en: "Editorial Evaluation - Impact",
            zh: "影响力水平评入库",
          },
          content:
            "从ESCI进入到SCIE/SSCI/AHCI仅需满足四个标准。但是千万不要小瞧这四个标准，有些期刊在ESCI库里徘徊了五六年，依旧无法跨越这个鸿沟。最后一个阶段主要是希望选择出特定研究领域中最具有影响力的期刊，主要使用期刊在WOS的数据库影响力，“引用”作为主要指标。最后四个标准不仅仅是对期刊、编辑部有要求，同时WOS编辑会参考本刊的发文作者，以及相对同领域内的竞品期刊的表现力等元素来作为筛选标准。同样的，如果期刊未通过这个阶段的审核，则重新评估将收到两年的禁止期。",
          stepsList: [],
        },
      ],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      getStandardList().then((res) => {
        res.data.map((item) => {
          this._data.standardList[item.category - 1].stepsList.push(item);
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
